module.exports = __webpack_public_path__ + "img/xrp_vs_xlm_pt1.2f24621b.png";